module.exports = __webpack_public_path__ + "img/apple-store.4cd41850.png";